<template>
  <v-container class="component_main px-3">
    <v-row>
      <v-col class="d-flex justify-end py-0 px-0" cols="12" sm="12" md="12">
          <v-btn
            color="primary"
            text
            @click="getFile('csv')"
            :disabled="list.length == 0"
          >
            <v-icon small class="pr-2">fa-download</v-icon>
            Exportar resultado
          </v-btn>
        </v-col>
      <div class="col-md-12">
        <v-data-table
          :headers="headers"
          :items="list"
          hide-default-footer
          :items-per-page="pagination.limit"
          dense
        >
          <!-- @page-count="pageCount = parseInt($event, 10)" -->
          <template v-slot:item="props">
            <tr style="cursor: pointer;" @click="selectItem(props.item, 'toggleStatus')">
              <td style="height: 100%;" class="text-center pa-2">{{props.item.req_datasolicitacao | formatDate}}</td>
              <td style="height: 100%;" class="text-center pa-2">{{listOperadora[(props.item.operadora_id).toString()]}}</td>
              <td style="height: 100%;" class="text-center pa-2">{{props.item.dom_tiposolicitacao_descricao}}</td>
              <td style="height: 100%;" class="text-center pa-2">{{props.item.res_guiaprestador}}</td>
              <td style="height: 100%;" class="text-center pa-2">{{props.item.res_guiaoperadora}}</td>
              <td style="height: 100%;" class="text-center pa-2">{{props.item.req_benef_carteira}}</td>
              <td style="height: 100%;" class="text-center pa-2">{{props.item.req_benef_nome}}</td>
              <td style="height: 100%;" class="text-center pa-2">
                <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="statusColors[props.item.res_statussolicitacao]"
                    x-small
                    icon
                    v-bind="attrs"
                    v-on="on"
                  ><v-icon small style="font-size:13px;">fa-circle</v-icon>
                  </v-btn>
                </template>
                <span class="pa-5">{{props.item.dom_statussolicitacao_descricao}}</span>
              </v-tooltip>
              <!-- <v-icon small :color="statusColors[props.item.res_statussolicitacao]">fa-circle</v-icon> -->
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div class="text-center mt-2 col-md-12">
        <v-pagination class="no-box-shadow" v-model="pagination.current_page" :length="pagination.total_pages" @input="getList"></v-pagination>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
moment.locale('pt-BR');
export default {
  data() {
    return {
    };
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L")
       + " " +
       moment(date).format("LT")
    },
  },
  props: {
    getFile: Function,
    getList: Function,
    headers: Array,
    list: Array,
    listOperadora:Object,
    pagination: Object,
    statusColors: Object,
    selectItem: Function,
  },
};
</script>

<style>
.no-box-shadow, .no-box-shadow *{
  box-shadow: 0 0 0 0!important;
  
}
</style>
